module.exports = __webpack_public_path__ + "static/scale-model-of-madame-tussauds-washington-dc-in-washington-d.c.-22d0478e95f19baba38bb5f35ddfa0ea.png";